{
  "action_group_candidate": "Candidate",
  "action_group_review": "Review",
  "action_group_survey": "Survey",
  "action_type_google_workspace": "Manage Google accounts",
  "action_type_google_workspace_action": "Action type",
  "action_type_google_workspace_create_user": "Create user",
  "action_type_google_workspace_delete_user": "Delete user",
  "action_type_google_workspace_description": "Add or remove a user in Google Workspace",
  "action_type_approval": "Survey with approval",
  "action_type_esign": "Request signatures",
  "action_type_candidate_email": "Email to candidate",
  "action_type_candidate_stage_change": "Change stage / disqualify",
  "action_type_candidate_stage_change_mode": "Action",
  "action_type_candidate_stage_change_mode_change_stage": "Change stage",
  "action_type_candidate_stage_change_mode_disqualify": "Disqualify",
  "action_type_meeting": "Meeting",
  "action_type_meeting_organizer": "Organizer",
  "action_type_meeting_calendar": "Calendar",
  "action_type_meeting_calendar_select_organizer": "Select an organizer first",
  "action_type_meeting_calendar_provider_google": "Google Calendar",
  "action_type_meeting_calendar_provider_system": "System calendar",
  "action_type_meeting_external_emails": "External guests",
  "action_type_meeting_external_emails_description": "Enter email",
  "action_type_meeting_location": "Location",
  "action_type_meeting_conference": "Add video conference",
  "action_type_meeting_conference_description": "Available only for a Google calendar",
  "meeting_date_label": "Meeting day",
  "meeting_date_reference_block_execution": "On the day the action runs",
  "meeting_date_reference_entity_date": "Relative to the employee date",
  "meeting_date_entity_label": "Employee date",
  "meeting_date_direction_label": "Before or after",
  "meeting_date_day_type_label": "Day type",
  "action_type_esign_acknowledgment_only": "Acknowledgment only",
  "action_type_esign_acknowledgment": "Acknowledgment",
  "action_type_esign_acknowledgment_hint": "Recipients read and confirm the document.",
  "action_type_esign_not_prepared": "Document is not prepared for signing",
  "action_type_esign_not_supported": "This file can't be signed or acknowledged",
  "action_type_esign_prepare": "Prepare for signing",
  "action_type_esign_request_type": "Request type",
  "action_type_esign_signatures_hint": "Recipients sign the document.",
  "action_type_esign_summary_acknowledgment": "Document acknowledgment",
  "action_type_esign_summary_signature": "Document signing",
  "approval_category": "Approval category",
  "approval_save_responses_after_approval": "After the request is approved",
  "approval_save_responses_after_nested_steps": "After all related steps are completed",
  "approval_save_responses_after_workflow": "After the entire flow is completed",
  "approval_survey_template": "Request questionnaire template",
  "approval_when_to_save_responses": "When to save responses to the employee profile",
  "action_type_http_request": "Send HTTP Request",
  "action_type_http_request_add_header": "Add header",
  "action_type_http_request_custom_headers": "Custom headers",
  "action_type_http_request_description": "Run an external API and post the data",
  "action_type_http_request_header_duplicate": "Duplicate header",
  "action_type_http_request_header_forbidden": "This header cannot be set manually",
  "action_type_http_request_header_invalid": "Enter a valid HTTP header name",
  "action_type_http_request_header_key": "Header",
  "action_type_http_request_header_reserved": "This header is reserved for the HMAC signature",
  "action_type_http_request_header_value": "Value",
  "action_type_http_request_payload_data": "Payload data (JSON)",
  "action_type_http_request_signature": "HMAC signature",
  "action_type_invitation": "Invitation",
  "action_type_invitation_body": "Invitation text",
  "action_type_run_workflow": "Start another flow",
  "action_type_run_workflow_target": "Flow to run",
  "action_type_run_workflow_steps": "Flow steps",
  "action_type_notification": "Send notification",
  "action_type_notification_body": "Body",
  "action_type_notification_message_text": "Message text",
  "action_type_notification_recipient_custom_field_employee_reference": "Employee from custom field",
  "action_type_notification_recipient_custom_field_employee_reference_subordinates": "Subordinates of employee from custom field",
  "action_type_notification_recipient_employee": "Employee",
  "action_type_notification_recipient_employee_manager": "Employee's manager",
  "action_type_notification_recipient_employee_managers_subordinates": "Employee's manager's subordinates",
  "action_type_notification_recipient_employee_subordinates": "Employee's subordinates",
  "action_type_notification_recipient_external_emails": "External email addresses",
  "action_type_notification_recipient_slack_channels": "Slack channel",
  "action_type_notification_recipient_specific_employee": "Specific employee",
  "action_type_notification_recipient_type": "To",
  "action_type_notification_skip_notification_to_affected_employee": "Skip notification to affected employee",
  "action_type_notification_skip_notification_to_affected_employee_description": "If enabled, employee will not receive this notification.",
  "action_type_notification_to_channels": "To channels",
  "action_type_survey": "Start survey",
  "action_type_survey_enroll": "Add employee to survey",
  "action_type_survey_enroll_description": "Add an employee to a running survey",
  "action_type_task": "Create task",
  "action_type_task_due_date": "Set due date",
  "action_type_task_due_date_delay_days": "Days to complete",
  "action_type_performance_review_add_employee": "Add employee to review",
  "action_type_performance_review_add_employee_description": "Add an employee to a running review",
  "performance_review_enroll_rules_conversion_warning_title": "In this review, participants are selected by rules \"{rules}\".",
  "performance_review_enroll_rules_conversion_warning_header": "To add a specific employee, this rule will be converted to an explicit employee list.",
  "performance_review_enroll_rules_conversion_warning_caption": "When you edit this review later, you will see a list of employees instead of the original rule.",
  "survey_enroll_rules_conversion_warning_title": "In this survey, participants are selected by rules \"{rules}\".",
  "survey_enroll_rules_conversion_warning_header": "To add a specific employee, this rule will be converted to an explicit employee list.",
  "survey_enroll_rules_conversion_warning_caption": "When you edit this survey later, you will see a list of employees instead of the original rule.",
  "actions": "Actions",
  "actions_count": "{count, plural, one {# action} other {# actions}}",
  "blocking_action_count": "Blocks {count, plural, one {# action} other {# actions}}",
  "blocking_action_type_task": "Complete task",
  "blocking_action_type_run_workflow": "Complete another flow",
  "blocking_action_description": "Next actions will start after this action has been performed and fully completed",
  "activate_automation": "Activate automation",
  "activate_automation_confirm": "Are you sure you want to activate automation for this flow?",
  "pause_automation": "Pause automation",
  "pause_automation_confirm": "Are you sure you want to pause automation for this flow?",
  "add_condition": "Add condition",
  "assign_workflow": "Assign flow",
  "assign_workflow_caption": "Assign and run a flow for this employee",
  "assign_workflow_success": "Flow assigned successfully",
  "benefits_and_approvals": "Benefits and approvals",
  "employee_workflows_empty_state_title": "No flows have been found",
  "employee_workflow_run_success": "The “{title}” flow has started. Its configured actions will begin shortly",
  "hire_blocking_hint": "Flows marked “Restricts access” must be completed before the employee gets full access to %APP_NAME%.",
  "blocking_portal_access": "Restricts access",
  "block_portal_access_enable": "Restrict portal access",
  "block_portal_access_disable": "Don't restrict portal access",
  "hire_choose_workflow": "Choose flow...",
  "workflow_launched": "Launched",
  "workflow_launch_failed": "Not launched",
  "hire_launch_workflows": "Launch flows",
  "hire_launch_workflows_hint": "Choose the flows to launch right after hiring.",
  "hire_workflows_title": "Flows",
  "more_requests": "More requests",
  "search_request": "Search request",
  "automation_setup": "Automation setup",
  "block": "Block",
  "choose_automation_trigger": "Choose automation trigger",
  "choose_automation_trigger_description": "An automated flow will run based on the selected trigger",
  "choose_workflow": "Choose flow",
  "condition": "Condition",
  "condition_entity_type": "Entity type",
  "condition_entity_type_employee": "Employee",
  "condition_entity_type_event": "Event",
  "condition_entity_type_time_off": "Time off",
  "condition_field": "Entity field",
  "condition_field_candidate_previous_stage": "Previous stage",
  "condition_operator": "Operator",
  "condition_value": "Value",
  "conditions": "Conditions",
  "conditions_empty": "No conditions yet. Click Add to choose when this flow should run.",
  "configure_actions": "Configure actions",
  "configure_automation_trigger": "Configure automation trigger",
  "configure_workflow": "Configure flow",
  "create_new": "Create new flow",
  "created_ago": "Created {time}",
  "public_title_label": "Public title",
  "do_not_use_automation_caption": "Configure it later or use a flow without automation",
  "do_not_use_automation_title": "Don't use automation",
  "event_type_candidate_created": "Candidate added",
  "event_type_candidate_created_when": "When a candidate is added",
  "event_type_candidate_created_when_example": "Candidate applies from the career site or is added to a job",
  "event_type_candidate_disqualified": "Candidate disqualified",
  "event_type_candidate_disqualified_when": "When a candidate is disqualified",
  "event_type_candidate_disqualified_when_example": "Candidate is rejected with a disqualification reason",
  "event_type_candidate_feedback_submitted": "Candidate feedback submitted",
  "event_type_candidate_feedback_submitted_when": "When candidate feedback is submitted",
  "event_type_candidate_feedback_submitted_when_example": "Interviewer fills in a scorecard for the candidate",
  "event_type_candidate_hired": "Candidate hired",
  "event_type_candidate_hired_when": "When a candidate is hired",
  "event_type_candidate_hired_when_example": "Candidate moves to a hired stage",
  "event_type_candidate_stage_changed": "Candidate stage changed",
  "event_type_candidate_stage_changed_when": "When a candidate moves to a stage",
  "event_type_candidate_stage_changed_when_example": "Candidate moves from one pipeline stage to another",
  "event_type_employee_compensation_changed": "Employee compensation changed",
  "event_type_employee_compensation_changed_when": "When employee compensation changes",
  "event_type_employee_compensation_changed_when_example": "Salary or compensation details are updated",
  "event_type_employee_employment_changed": "Employee employment changed",
  "event_type_employee_employment_changed_when": "When employee employment details change",
  "event_type_employee_employment_changed_when_example": "Employment type, contract, or work pattern is updated",
  "event_type_employee_hired": "Employee hired",
  "event_type_employee_hired_when": "When an employee is hired",
  "event_type_employee_hired_when_example": "New employee is added through the hiring flow",
  "event_type_employee_position_changed": "Employee position changed",
  "event_type_employee_position_changed_when": "When an employee's position changes",
  "event_type_employee_position_changed_when_example": "Position details such as job title, department, or legal entity are updated",
  "event_type_employee_terminated": "Employee terminated",
  "event_type_employee_terminated_when": "When an employee is terminated",
  "event_type_employee_terminated_when_example": "Employee termination is completed",
  "event_type_offer_approved": "Offer approved",
  "event_type_offer_approved_when": "When an offer is approved",
  "event_type_offer_approved_when_example": "Offer approval is completed by all approvers",
  "event_type_offer_rejected": "Offer declined",
  "event_type_offer_rejected_when": "When an offer is declined",
  "event_type_offer_rejected_when_example": "An approver declines the offer",
  "event_type_time_off_request_approved": "Time off request approved",
  "event_type_time_off_request_approved_when": "When time off request is approved",
  "event_type_time_off_request_approved_when_example": "Leave request changes status to Approved",
  "event_trigger_moment_created": "Immediately when the record is created",
  "event_trigger_moment_effective": "When the change takes effect",
  "events": "Events",
  "executions": "Executions",
  "if": "If",
  "last_run_at": "Last run at",
  "list_of_conditions": "List of conditions",
  "operator_contains": "Contains",
  "operator_ends_with": "Ends with",
  "operator_equals": "Equals",
  "operator_greater_than": "Greater than",
  "operator_greater_than_or_equal": "Greater than or equal to",
  "operator_in": "Is in",
  "operator_is_not_null": "Is not empty",
  "operator_is_null": "Is empty",
  "operator_less_than": "Less than",
  "operator_less_than_or_equal": "Less than or equal to",
  "operator_not_contains": "Does not contain",
  "operator_not_equals": "Not equals",
  "operator_not_in": "Is not in",
  "operator_starts_with": "Starts with",
  "run_flow": "Run flow",
  "run_workflow": "Run flow",
  "runs_count": "Runs",
  "skip_and_activate_later": "Skip and activate later",
  "status_is_active": "Active",
  "status_is_inactive": "Stopped",
  "time_sensitive": "Time sensitive",
  "trigger_label_event": "Event trigger",
  "trigger_label_manual": "Manual trigger",
  "trigger_label_recurring": "Recurring trigger",
  "trigger_label_scheduled": "Scheduled trigger",
  "trigger_recurring_calendar_rule": "Repeat by",
  "trigger_recurring_calendar_rule_month_day": "Day of month",
  "trigger_recurring_calendar_rule_ordinal_weekday": "Weekday position",
  "trigger_recurring_description_at": "at {time}",
  "trigger_recurring_description_daily": "Every day",
  "trigger_recurring_description_monthly_day": "{interval}, on day {day}",
  "trigger_recurring_description_monthly_ordinal": "{interval} — weekday: {weekday}, position: {ordinal}",
  "trigger_recurring_description_starting": "starting {date}",
  "trigger_recurring_description_until": "until {date}",
  "trigger_recurring_description_weekly": "{interval} on {days}",
  "trigger_recurring_description_yearly_day": "{interval}, on {month} {day}",
  "trigger_recurring_description_yearly_ordinal": "{interval}, in {month} — weekday: {weekday}, position: {ordinal}",
  "trigger_recurring_end": "Ends",
  "trigger_recurring_end_type": "End condition",
  "trigger_recurring_end_count_label": "Number of runs",
  "trigger_recurring_end_never": "Never",
  "trigger_recurring_end_until": "On a date",
  "trigger_recurring_end_count": "After a number of runs",
  "trigger_recurring_frequency": "Repeat",
  "trigger_recurring_every_month": "Every month",
  "trigger_recurring_every_week": "Every week",
  "trigger_recurring_every_year": "Every year",
  "trigger_recurring_month": "Month",
  "trigger_recurring_month_day": "Day of month",
  "trigger_recurring_option": "On a recurring schedule",
  "trigger_recurring_option_description": "Start the flow automatically on selected days",
  "trigger_recurring_repeat_every": "{repeat} {every}",
  "trigger_recurring_section_start": "Start",
  "trigger_recurring_schedule_not_configured": "Recurring schedule is not configured yet",
  "trigger_recurring_ordinal": "Which week of the month",
  "trigger_recurring_ordinal_1": "First",
  "trigger_recurring_ordinal_2": "Second",
  "trigger_recurring_ordinal_3": "Third",
  "trigger_recurring_ordinal_4": "Fourth",
  "trigger_recurring_ordinal_last": "Last",
  "trigger_recurring_title": "Recurring schedule",
  "trigger_recurring_task_assignee_error": "Select specific employees for a recurring flow",
  "trigger_recurring_weekday_recurring_fr": "Fridays",
  "trigger_recurring_weekday_recurring_mo": "Mondays",
  "trigger_recurring_weekday_recurring_sa": "Saturdays",
  "trigger_recurring_weekday_recurring_su": "Sundays",
  "trigger_recurring_weekday_recurring_th": "Thursdays",
  "trigger_recurring_weekday_recurring_tu": "Tuesdays",
  "trigger_recurring_weekday_recurring_we": "Wednesdays",
  "trigger_recurring_weekday": "Day of week",
  "trigger_recurring_weekdays": "Days of week",
  "trigger_schedule_entity_field_date_start": "start",
  "trigger_schedule_entity_field_hire_date": "Start date",
  "trigger_schedule_entity_field_hire_date_example": "N days before start date",
  "trigger_schedule_entity_field_probation_ends_date": "Probation end date",
  "trigger_schedule_entity_field_probation_ends_date_example": "N days before probation end date",
  "trigger_schedule_entity_field_terminate_date": "Termination date",
  "trigger_schedule_entity_field_terminate_date_example": "N days before termination date",
  "trigger_schedule_entity_field_birthday": "Birthday",
  "trigger_schedule_entity_field_birthday_example": "N days before birthday",
  "trigger_schedule_entity_field_work_anniversary": "Work anniversary",
  "trigger_schedule_entity_field_work_anniversary_example": "N days before work anniversary",
  "trigger_schedule_entity_field_custom_field": "Date from a field",
  "trigger_schedule_entity_field_custom_field_example": "N days before the date in an employee custom field",
  "trigger_schedule_entity_field_custom_table_column": "Date from a table",
  "trigger_schedule_entity_field_custom_table_column_example": "N days before the date in a custom table column",
  "trigger_schedule_date_field": "Date field",
  "trigger_schedule_date_field_placeholder": "Choose a field",
  "trigger_schedule_date_field_historical_hint": "The table keeps history, so the date is taken from the current row",
  "trigger_schedule_is_annual_title": "Repeat every year",
  "trigger_schedule_is_annual_description": "Run the flow every year on this date, not only once",
  "trigger_schedule_entity_type_employee": "Employee",
  "trigger_schedule_entity_type_time_off": "Time off",
  "trigger_schedule_entity_type_time_off_example": "N days before time off starts",
  "trigger_schedule_catch_up_hint": "If the scheduled time has already passed, the flow will start immediately, as long as the related event has not started yet",
  "trigger_schedule_day_type": "Day type",
  "trigger_schedule_hour": "Start hour",
  "trigger_schedule_timezone_employee": "Employee timezone",
  "trigger_schedule_timezone_organization": "Organization timezone",
  "trigger_schedule_timezone_custom": "Select manually",
  "trigger_schedule_timezone_hint": "If the employee or organization timezone changes before the flow starts, the scheduled time will be recalculated. A manually selected timezone remains fixed.",
  "trigger_schedule_summary_employee_timezone": "{schedule}, at {hour}:00 in the employee's timezone",
  "trigger_schedule_summary_organization_timezone": "{schedule}, at {hour}:00 in the organization's timezone",
  "trigger_schedule_summary_custom_timezone": "{schedule}, at {hour}:00, {timezone}",
  "trigger_schedule_template_after": "{offset} after {field} of {entity}",
  "trigger_schedule_template_at": "On {field} of {entity}",
  "trigger_schedule_template_before": "{offset} before {field} of {entity}",
  "block_delay_reference": "Count from",
  "block_delay_reference_previous_block": "After the previous step",
  "block_delay_reference_trigger_date": "Relative to the event date",
  "block_delay_trigger_date_unavailable_hint": "Event-relative timing is available only for flows with a scheduled event date",
  "block_delay_trigger_date_timezone_hint": "The action uses the timezone selected in the scheduled trigger. Its deadline may change if the event date, timezone, or working calendar changes",
  "block_delay_without_delay": "without delay",
  "block_delay_after_previous_block_summary": "{offset} after the previous step",
  "block_delay_after_trigger_summary": "{offset} after trigger",
  "block_delay_immediately_after_trigger_summary": "Immediately after trigger",
  "block_delay_immediately_after_previous_block_summary": "Immediately after the previous step",
  "block_delay_after_scheduled_trigger_summary": "{offset} after the scheduled flow start",
  "block_delay_before_event_summary": "{offset} before {event}",
  "block_delay_after_event_summary": "{offset} after {event}",
  "block_delay_on_event_day_summary": "On {event} at {hour}:00",
  "block_delay_event_date_start": "the time off start date",
  "block_delay_event_hire_date": "the start date",
  "block_delay_event_terminate_date": "the termination date",
  "block_delay_event_probation_ends_date": "the probation end date",
  "block_delay_event_birthday": "the birthday",
  "block_delay_event_work_anniversary": "the work anniversary",
  "block_delay_event_custom_field": "the date from a field",
  "block_delay_event_custom_table_column": "the date from a table",
  "block_delay_event_custom_date": "“{title}”",
  "execution_block_cancel_reason_block_deleted": "Cancelled: the block was removed from the workflow",
  "execution_block_cancel_reason_candidate_state_changed": "Cancelled: the candidate changed stage, was disqualified or archived",
  "execution_block_cancel_reason_esign_envelope_cancelled": "Cancelled: the signature request was cancelled manually",
  "execution_block_cancel_reason_source_event_cancelled": "Cancelled: the triggering event was reverted",
  "execution_block_effective_due_at": "Current deadline",
  "execution_block_effective_due_at_hint": "The deadline may change if the event date, timezone, or working calendar changes",
  "execution_block_failed": "Block execution failed",
  "execution_block_meeting_created": "Meeting created",
  "execution_block_meeting_open": "Open meeting",
  "execution_block_meeting_unavailable": "The meeting is not available to you",
  "variable_anniversary_short_date": "Work anniversary (day & month)",
  "variable_anniversary_years": "Work anniversary (years)",
  "variable_birthday_date": "Birthday (full date)",
  "variable_birthday_short_date": "Birthday (day & month)",
  "variable_birthday_years": "Age",
  "variable_group_assignee": "Assignee",
  "visibility_description": "Choose who can use this flow.",
  "visibility_employee_preview": "Employee preview",
  "visibility_employee_preview_description": "This is how employees will see this flow.",
  "visibility_make_available": "Make available to employees",
  "visibility_make_available_description": "Employees will be able to access and run this flow in profile",
  "when": "When",
  "run": "Run",
  "workflow": "Flow",
  "workflow_details_label": "Flow details",
  "workflow_run_success": "Flow started successfully",
  "view_or_edit_workflow": "View or edit flow",
  "workflow_has_been_updated_description": "The automation continues running with the new settings",
  "workflow_has_been_updated_title": "Changes saved",
  "workflow_is_ready_to_launch_description": "It's currently off. Once activated, all users who match the criteria will start receiving tasks, emails, and everything you configured",
  "workflow_is_ready_to_launch_title": "Automation is ready. Activate it now?",
  "workflow_module": "Access to flow module",
  "workflow_module_description": "Required for all flow interactions.",
  "workflow_trigger_type_event": "Event",
  "workflow_trigger_type_manual": "Manual",
  "workflow_trigger_type_recurring": "Recurring",
  "workflow_trigger_type_scheduled": "Scheduled",
  "all_workflows": "All flows",
  "category": "Category",
  "create_category": "Create category",
  "create_category_description": "To organize flows",
  "edit_category": "Edit category",
  "delete_category": "Delete category",
  "delete_category_named": "Delete category {title}",
  "delete_category_confirm": "Are you sure you want to delete category {title}?",
  "delete_category_unavailable": "Cannot delete category",
  "delete_category_contains_workflows": "This category contains flows",
  "empty_workflows_title": "No flows yet",
  "empty_workflows_description": "Create your first flow to automate routine tasks",
  "workflows": "Flows",
  "workflows_create": "Create new flow",
  "workflows_create_description": "Allow creating flows for automation",
  "workflows_executions": "View flow executions",
  "workflows_executions_description": "Track status and execution history of flows in the system",
  "workflows_manage_all": "Manage all flows",
  "workflows_manage_all_description": "Edit, configure or delete any flows and flow categories in the system",
  "workflows_manual_run": "Manual run flow",
  "workflows_manual_run_description": "Run a flow manually",
  "summary": "Summary",
  "summary_completion_rate": "Completion rate",
  "recent_executions_description": "Recent flow runs",
  "execution_details": "Execution details",
  "execution_started_at": "Started at",
  "execution_duration": "Duration",
  "execution_steps": "Steps",
  "execution_block_started_at": "Started at",
  "execution_block_completed_at": "Completed at",
  "execution_block_scheduled_at": "Scheduled at",
  "execution_will_start_soon": "The flow will start shortly",
  "execution_will_start_not_before": "The flow will start no earlier than {datetime}",
  "cancel_execution": "Cancel execution",
  "cancel_execution_short": "Cancel execution",
  "cancel_execution_submit": "Cancel",
  "cancel_execution_confirm": "The flow will stop. Pending approval requests with their unfilled surveys, unsigned envelopes and child executions will be cancelled. Tasks, meetings and other surveys will stay. Are you sure you want to cancel this execution?",
  "move_block_up": "Move up",
  "move_block_down": "Move down",
  "indent_block": "Indent under previous",
  "outdent_block": "Move out one level",
  "~": "~",
  "action_type_notification_recipient_candidate_job_recruiters": "Job recruiters",
  "action_type_notification_recipient_candidate_job_stakeholders": "Job stakeholders"
}
